<template>
    <ExtendedLayout
        :user="user"
        currentTab="vacations"
    >

        <Panel>

            <Heading type="h2" class="flex items-center gap-2 mb-4">
                <InertiaLink :href="$route('admin::users.vacations.index', { user: user.id })">
                    <ChevronLeftIcon class="w-4 h-4 text-gray-500" />
                </InertiaLink>
                {{ __('admin::general.edit_model', {'model': __('admin::vacations.vacation').toLowerCase() }) }}
            </Heading>

            <form @submit.prevent="submit">

                <VacationForm
                    v-model="form"
                    :userOptions="userOptions"
                    :vacationMessageDefault="vacationMessageDefault"
                    managerMode
                />

                <Button :loading="form.processing">
                    {{ __('admin::general.update_model', {'model': __('admin::vacations.vacation').toLowerCase() }) }}
                </Button>

            </form>

        </Panel>

    </ExtendedLayout>
</template>

<script>
import ExtendedLayout from '@A/Pages/Users/Edit';
import {ChevronLeftIcon} from "@heroicons/vue/outline";

export default {
    components: {
        ChevronLeftIcon,
        ExtendedLayout,
    },
    props: {
        user: Object,
        vacation: Object,
        userOptions: Object,
        vacationMessageDefault: Object,
    },
    data() {
        return {
            form: this.$inertia.form({
                starts_at: this.vacation.starts_at,
                ends_at: this.vacation.ends_at,
                returns_at: this.vacation.returns_at,
                days_to_show_notice_before_start: this.vacation.days_to_show_notice_before_start,
                deputy_user_id: this.vacation.deputy_user_id,
                comment: this.vacation.comment,
                use_default_messages: this.vacation.use_default_messages,
                appendix_before_vacation_message: this.vacation.appendix_before_vacation_message,
                appendix_during_vacation_message: this.vacation.appendix_during_vacation_message,
                autoreply_subject: this.vacation.autoreply_subject,
                autoreply_message: this.vacation.autoreply_message,
                is_approved: this.vacation.is_approved,
                synced_with_salary: this.vacation.synced_with_salary,
            })
        }
    },
    methods: {
        submit() {
            this.form
                .transform((data) => ({
                    ...data,
                    _method: 'patch',
                }))
                .post(this.$route('admin::users.vacations.update', { user: this.user.id, vacation: this.vacation.id }));
        },
    }
}
</script>
